import { Injectable } from '@angular/core';

/**
 * Root bridge so root-provided services (e.g. the AI assistant response handler) can change the
 * global reference date. The DigitalTwin component registers the canonical change path on init
 * (the same one the toolbar date picker and URL param go through), so the toolbar picker, repairs
 * reload and view-mode reapplication all stay in sync. Mirrors VisualizationModeBridgeService.
 *
 * It also holds the date 3D is showing, which AssetManager keeps current, for root services
 * AssetManager itself depends on (the inspection save needs it to date executed work).
 */
@Injectable({
  providedIn: 'root'
})
export class ReferenceDateBridgeService {
  private handler: ((date: Date) => void) | null = null;

  current: Date | null = null;

  register(handler: (date: Date) => void): void {
    this.handler = handler;
  }

  requestChange(date: Date): void {
    this.handler?.(date);
  }
}
